import {environment} from '../../environments/environment';
import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CartDto } from '../dtos/CartDto';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(
    private httpClient: HttpClient,
  ) {

  }

  public getCart(id: string): Observable<CartDto> {
    return this.httpClient.get<CartDto>(`${environment.apiUrl}/carts/${id}`);
  }

  public addToCart(productId: string): Observable<CartDto> {
    const cartId = localStorage.getItem('cartId');

    return this.httpClient.post<CartDto>(
        `${environment.apiUrl}/carts/addProduct`,
        {
            cartId,
            productId: productId
        }
    );
  }

  public removeFromCart(productId: string): Observable<CartDto> {
    const cartId = localStorage.getItem('cartId');

    return this.httpClient.post<CartDto>(
        `${environment.apiUrl}/carts/removeProduct`,
        {
            cartId,
            productId: productId
        }
    );
  }

  public deleteCart() {
    const cartId = localStorage.getItem('cartId');

    if(!cartId) return;

    return this.httpClient.delete(
        `${environment.apiUrl}/carts/deleteCart/${cartId}`
    );
  }

  public isEmpty(): boolean {
    const cartId = localStorage.getItem('cartId');

    if (!cartId) return true;
    else return false;
}
}
